<!-- 地图小弹窗菜单 -->
<template>
  <!-- 地图右上角菜单 组件-->
  <div class="new_warn_pan">
    <div class="warn_left">
      <div :class="[isDefaultTheme ? 'icon1_online' : 'icon1_online_m']"></div>
      <span>{{ $t('OnlineEquipment') }}：</span>
      <span>{{ onlinePersons ? onlinePersons : 0 }}</span>
    </div>
    <div class="line"></div>
    <div @click="_triggerHelmet" class="warn_right">
      <div :class="[isDefaultTheme ? 'icon2_warn' : 'icon2_warn_m']"></div>
      <span>{{ $t('equipmentAlarm') }}：</span>
      <span>{{ mapMenuData.warnNumb }}</span>
    </div>
    <!-- <div class="line"></div>
    <div class="warn_left" @click="openFencePan()">
      <div :class="[isDefaultTheme ? 'fence_day' : 'fence_m']"></div>
      <span>{{ $t('Electronicfence') }}</span>
      <div class="fenceSearchPan" v-if="isOpenFencePan">
        <el-input
          :placeholder="$t('nameElectronicFence')"
          class="fenceSerachBarInput"
          clearable
          v-model="fenceName"
          @click.stop.native
        >
        </el-input>
        <el-tree
          :data="fenceData.treedataList"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          @node-click="fenceNodeClick"
          highlight-current
          class="fenceTree"
          ref="dataConfigTree"
          :props="defaultProps"
        >
        </el-tree>
      </div>
    </div> -->
    <div class="popover" :class="theme === 'midnight' ? 'popover-dark' : 'popover-light'" v-if="visible">
      <span class="unread">{{ $t('unread') }}</span
      ><span class="check-view" @click="toConver($t('VoiceMessage'))">{{ $t('check') }}！</span>
      <img @click="closeTip" class="close" src="@/icon/ic_cancle.png" alt="" />
    </div>
    <!-- 设备告警=>具体分类告警 -->
    <div class="warn_pan_pop"  v-if="triggerHelmet && mapMenuData.warnNumb">
      <div
        class="warn_pan_pop_block"
        :class="langue === 'en' ? 'en_pop' :''"
        v-for="item of mapMenuData.warnList"
        :key="$t(item.alertName)"
        @click="handleAlarm(item)"
      >
        <!-- 被5整除的数不用加竖线 -->
        <!-- <div class="line" v-if="index % 5 != 0"></div> -->
        <div class="flexColumn">
          <span class="number">{{ item.number }}</span>
          <span class="des">{{ $t(item.alertName) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { geofenceList, getOus } from '@/api/fence'

export default {
  props: {
    theme: {
      type: String,
    },
    onlinePersons: {
      type: String,
    },
    mapMenuData: {
      type: Object,
    },
    visible: {
      type: Boolean,
    },
    zoom: {
      type: Number,
    },
    newFenceDialogTableVisible: {
      type: Boolean,
    },
    markerPoint: {
      type: Object,
    },
  },
  data() {
    return {
      fenceName: '',
      // 告警安全帽面板开关
      triggerHelmet: false,
      isOpenFencePan: false,
      // 机构树设备数据
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      fenceData: {
        checkedList: [],
        ouList: [],
        currEditName: '',
        treedataList: [],
      },
      // 当前语言
      langue: localStorage.getItem('lang')
    }
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
  methods: {
    closeTip() {
      this.$emit('closeTip')
    },
    openFencePan() {
      this.isOpenFencePan = !this.isOpenFencePan
      this.$emit('openFencePan')
      getOus().then(res => {
        if (res.state === 0) {
          this.fenceData.ouList = res.data
          this._geofenceList()
        }
      })
    },
    // 显示设备告警具体类型
    _triggerHelmet() {
      this.triggerHelmet = !this.triggerHelmet
    },
    // 点击跳转处理告警
    handleAlarm(item) {
      if (this.triggerHelmet) {
        this.$router.push({
          path: '/newIndex/newSet/caution',
          query: { currentPath: 'caution' },
        })
        this.$store.commit('currentIndex', 'set')
      }
    },
    // 展开电子围栏列表
    _geofenceList(other) {
      let param = {}
      if (other) {
        param = {
          name: other,
        }
      }
      geofenceList(param).then(res => {
        this.fenceData.treedataList = res.data
        this.fenceData.treedataList.forEach(item => {
          item.pointData = JSON.parse(item.pointData)
        })
        console.log(this.fenceData.treedataList)
      })
    },
    // 围栏节点点击事件
    fenceNodeClick(data) {
      this.$emit('update:markerPoint', data.pointData[0])
      let treedataList = this.fenceData.treedataList
      treedataList.forEach(item => {
        if (item.id === data.id) {
          treedataList = []
          treedataList.push(item)
        }
      })
      this.fenceData.polygonObj.info.data = []
      this.fenceData.polylineObj.info.data = []
      this.fenceData.circleObj.info.data = []
      if (data.type === 1) {
        this.fenceData.polylineObj.info.data = treedataList
      } else if (data.type === 2) {
        this.fenceData.polygonObj.info.data = treedataList
      } else {
        this.fenceData.circleObj.info.data = treedataList
      }
    },
    // 电子围栏关闭
    handleClose() {
      this.$emit('update:newFenceDialogTableVisible', false)
    },
  },
  watch: {
    fenceName() {
      this._geofenceList()
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.new_warn_pan
  padding 9px 11px
  display flex
  position absolute
  left: 45%;
  top: 19px;
  pointer-events: auto
  background-color: #fff
  border-radius: 4px
  // bg-image('~@/icon/newBg/warn_bg.png')
  .warn_left
    display flex
    align-items center
    .fenceSearchPan
      position absolute
      top 106%
      right 0%
      background var(--fence-bg)
      box-shadow 0px 3px 4px 0px rgba(0, 0, 0, 0.1)
      .fenceSerachBarInput
        margin 10px
      .fenceTree
        overflow auto
        height 270px
        color #ccc
        background var(--fence-tree-bg) !important
    span
      font-weight bold
      font-size 15px
    .icon1_online
      width 30px
      height 30px
      bg-image('~@/icon/helmet_online.png')
    .icon1_online_m
      width 30px
      height 30px
      bg-image('~@/icon/re-new-command/helmet_online_m.png')
    .fence_day
      width 30px
      height 30px
      bg-image('~@/icon/fence_day.png')
      background-size 100%
    .fence_m
      width 30px
      height 30px
      bg-image('~@/icon/fence_m.png')
      background-size 100%
  .line
    width 1px
    height 30px
    margin 0 15px
  .disable
    pointer-events none
  .warn_right
    cursor pointer
    display flex
    align-items center
    span
      font-weight bold
      font-size 15px
    .icon2_warn
      width 30px
      height 30px
      bg-image('~@/icon/helmet_warn.png')
    .icon2_warn_m
      width 30px
      height 30px
      bg-image('~@/icon/re-new-command/helmet_warn_m.png')
  .popover
    position absolute
    bottom -50px
    left 50%
    transform translate(-80%, 0)
    width 230px; /* no */
    height 45px
    -moz-background-size 100% 100%
    background-size 100% 100%
    border-radius 4px
    line-height 40px
    padding-left 14px
    display: flex
    align-items: center
    z-index 99999
    .check-view
      cursor pointer
    .close
      cursor pointer
  .popover-dark
    bg-image('~@/icon/ic_show_tip.png')
    z-index: 99999;
  .popover-light
    bg-image('~@/icon/show_tip.png')
.voice-mon
  position relative
  cursor pointer
  display flex
  align-items center
  .voice-icon
    display inline-block
    width 30px
    height 30px
    background-size 100%
  .voice-light
    bg-image('~@/icon/yuyin.png')
  .voice-dark
    bg-image('~@/icon/ic_yuyin.png')
  .voice-title
    font-weight bold
    font-size 15px
.voice-item
  font-weight 400
  font-size 15px
.warn_pan_pop
  display flex
  align-items center
  flex-wrap wrap
  position absolute
  right 0px
  top 55px
  padding: 4px 11px 11px 11px;
  justify-content: space-between;
  box-shadow 0px 3px 4px 0px rgba(0, 0, 0, 0.1)
  border-radius 4px
  // bg-image('~@/icon/new-command/history/opacity-bg.png')
  background #fff
  .line
    width 1px
    height 30px
    margin 0 15px
  .warn_pan_pop_block
    margin-top: 6px
    display flex
    align-items center
    height: 45px
    cursor pointer
    padding 5px 15px
    border: 1px solid #3252B0
    justify-content: center;
    // width: 22%;
    .number
      font-size 16px
      font-weight bold
    .des
      font-size 12px
.en_pop
  width 40%
// 深色模式样式覆盖
.theme-dark
  .new_warn_pan
    background-color: rgba(#052D84,0.8)
  .warn_pan_pop
    background-color: #052D84
</style>
